import {useStatesStorage} from "@/stores/store";
import {storeToRefs} from "pinia";
import {saveArticleAJ, saveRubricAJ} from "@/api/http";

export const AddOrUpdateArticleById = (articles, new_article, rubric_id, article_id, newId, newDate) => {

    if(new_article.id == null) {
        new_article.id = newId;
        new_article.date = newDate;
        articles.value.push(new_article);
        return true;
    }

    for (let i in articles.value)
    {
        let articleObj = articles.value[i];

        if(articleObj.id == article_id) {
            articles.value[i] = JSON.parse(JSON.stringify(new_article))
            return true;
        }
    }

    return false;
}

export const AddOrUpdateRubricById = (rubrics, new_rubric, rubric_id, newId) => {

    if(new_rubric.id == null) {
        new_rubric.id = newId;
        rubrics.value.push(new_rubric);
        return true;
    }

    for (let i in rubrics.value)
    {
        let rubricObj = rubrics.value[i];

        if(rubricObj.id == rubric_id) {
            rubrics.value[i] = JSON.parse(JSON.stringify(new_rubric))
            return true;
        }
    }

    return false;
}

export const cleanContentLangFromValidateField = (content_lang) => {
    let newContentLang = {};

    for(let lang in content_lang) {
        const content_langObj = content_lang[lang];

        newContentLang[lang] = {
            'title' : content_langObj.title.value,
            'content' : content_langObj.content.value,
            'meta_text' : content_langObj.meta_text,
            'status' : content_langObj.status
        }
    }

    return newContentLang;
}

export const prepareSaveRubricAJ = (rubricObj) => {
    const statesStorage = useStatesStorage();
    const { viewStates } = storeToRefs(statesStorage);

    viewStates.save_in_process = true;

    return saveRubricAJ(rubricObj).then(r => {
        viewStates.save_in_process = false;
        if(r.ok)
        {
            alert('Сохранение успешное');

            return r;
        }
        else
        {
            throw new Error(r.error);
        }
    }).catch((error) => {
        alert(error)
        return false;
    });
};

export const prepareSaveArticleAJ = (articleObj) => {
    const statesStorage = useStatesStorage();
    const { viewStates } = storeToRefs(statesStorage);

    viewStates.save_in_process = true;

    return saveArticleAJ(articleObj).then(r => {
        viewStates.save_in_process = false;

        if(r.ok)
        {
            alert('Сохранение успешное');
            return r;
        }
        else
        {
            throw new Error(r.error);
        }
    }).catch((error) => {
        alert(error)
        return false;
    });
};